import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const ListAutorizarRequisasMantenimiento = async() => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimiento`, 'POST')
    return result;
}

// LISTA DE REQUISAS ASIGNADAS 
export const ListRequisasMantenimiento = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListRequisasMantenimiento`, 'POST',dates)
    return result;
}

export const ListAutorizarRequisasMantenimientoMateriales = async() => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimientoMateriales`, 'GET')
    return result;
}

export const ListAutorizarRequisasMantenimientoMASS = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimientoMASS`, 'GET', dates)
    return result;
}

export const ListAutorizarRequisasMantenimientoUniformes = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListAutorizarRequisasMantenimientoUniformes`, 'GET', dates)
    return result;
}

export const ListRequisasPendienteDespachoMantenimiento = async(dates) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/ListRequisasPendienteDespachoMantenimiento`, 'POST', dates)
    return result;
}

export const SPPermisosRequisasDeMateriales = async(detalles, ClaveAutorizacion) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/SPPermisosRequisasDeMateriales`, 'POST', {detalles, ClaveAutorizacion})
    return result;
}

// CANCELAR REQUISA MANTENIMIENTO
export const cancelarRequisasMantenimiento = async(data) => {
    const result = await PrivateInterceptor(`Mantenimiento/Requisas/cancelarRequisasMantenimiento`, 'POST', data)
    return result;
}
